<section>
    <h1 class="mat-display-1">Terms and Conditions: Discount Codes</h1>
</section>
<div class="content">
    <mat-accordion>
        <div>
            @for(term of terms; track term.id; let first = $first){
                <mat-expansion-panel [expanded]="(!fragment() && first) || fragment() == term.id">
                    <mat-expansion-panel-header>
                        <h3 [id]="term.id">{{term.title}}</h3>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                        <p class="mb-10">
                            These terms and conditions apply to cloudigo’s promotion named ‘{{term.title}}’ (‘Promotion’), redeemable by the use of a code (‘Discount Code’) on the cloudigo application, promoted on the cloudigo application and/or website (‘Platform’), between <span class="font-bold">{{term.start | date: 'longDate'}}</span> and <span class="font-bold">{{term.end | date: 'longDate'}}</span> (“Promotion Period”).  
                            <br/><br/>
                            @if(term.intro){
                                <span [innerHTML]="term.intro"></span>
                            } @else {
                                <span>
                                    The Discount Code allows you to obtain the cloudigo Premium Yearly Plan at a discounted price when you subscribe to the cloudigo Premium Yearly Plan during the Promotion Period. The following conditions apply to use of the Promotion.
                                </span>
                            }
                        </p>
                        <div [innerHTML]="term.content">
                        </div>
                    </ng-template>
                </mat-expansion-panel>
            }
        </div>
    </mat-accordion>
</div>